import { useCallback } from 'react';
import { useMutation } from 'pulse/react';
import { CloseTicketMutation } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.mutations';
import { GetTicketDetailsRpc, SearchTicketsRpc } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.resources';
import { getTicketDetailsParams } from './useTicket';
export const useCloseTicket = () => {
  const [mutate, {
    loading,
    data,
    error
  }] = useMutation(CloseTicketMutation);
  const handleCloseTicket = useCallback(id => {
    mutate({
      params: {
        ticketId: id
      }
    }, {
      resolved: async ({
        invalidateAll
      }) => {
        invalidateAll({
          resource: SearchTicketsRpc
        });
        await GetTicketDetailsRpc.refetch(getTicketDetailsParams(id));
      }
    }).catch(() => {});
  }, [mutate]);
  return {
    closeTicket: handleCloseTicket,
    isTicketClosing: loading,
    isCompleted: !loading && (data !== undefined || error !== null),
    error
  };
};